/* jshint esversion: 6 */

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

//  import axios from 'axios'
//  window.axios = axios;
// require('./bootstrap');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('example', require('./components/Example.vue'));

import '@/config';

import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import VueNotifications from 'vue-notifications';
import Alerts from 'vue-notification';
import iziToast from 'izitoast';
import 'izitoast/dist/css/iziToast.min.css';
import { GoogleCharts } from 'google-charts';
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import BootstrapVue from 'bootstrap-vue';
import FileUpload from 'vue-upload-component';
import momentbd from 'moment-business-days';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// var VueTruncate = require('vue-truncate-filter');
import VueTruncate from 'vue-truncate-filter';
import AlertsMixin from '@/mixins/AlertsMixin';
import UrlParsers from '@/mixins/UrlParsers';
import FormErrors from '@/mixins/FormErrors';
import App from '@/App';
import { i18n, loadLang } from '@/_translate';
import { Backend } from '@/_axios';
import store from '@/store';
import router from './router';
import SelectOnFocus from './directives/SelectOnFocus';

library.add(fas, far);

function toast({ title, message, type, timeout, cb }) {
  if (type === VueNotifications.types.warn) type = 'warning';
  return iziToast[type]({ title, message, timeout });
}

const token = store.getters['Auth/token'];
if (token && token.length > 0) {
  Backend.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

loadLang(i18n.locale, true);

iziToast.settings({
  position: 'topRight'
});

Vue.use(BootstrapVue);
Vue.mixin(FormErrors);
Vue.mixin(UrlParsers);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(Alerts, { componentName: 'Alerts' });
Vue.mixin(AlertsMixin);

Vue.filter('numFormat', numFormat(numeral));
numeral.localeData().delimiters.thousands = ' ';

Vue.use(VueNotifications, options);
Vue.component('file-upload', FileUpload);

Vue.directive('select-on-focus', SelectOnFocus);

window.EventBus = new Vue();
window.moment = momentbd;

Vue.use(VueTruncate);
/* eslint-disable no-new */
const app = new Vue({
  i18n,
  el: '#app',
  router,
  template: '<App/>',
  components: { App, FileUpload, VueNotifications, GoogleCharts },
  store,
  computed: {
    // ...mapGetters('Filters', ['filters'])

    ...mapGetters('Auth', ['isLoggedIn']),
  },
  methods: {
    // ...mapActions('Auth', [
    //     'LOAD_USER_INFO'
    // ]),
    // ...mapActions('JiraUsers', [
    //     'LOAD_JIRA_USERS'
    // ])
    ...mapActions({
      LOAD_USER_INFO: 'Auth/LOAD_USER_INFO',
      loadJiraUsers: 'JiraUsers/LOAD_JIRA_USERS',
      loadJiraActiveUsers: 'JiraUsers/LOAD_JIRA_ACTIVE_USERS',
      loadJiraWorklogs: 'Worklogs/LOAD_JIRA_WORKLOGS',
      loadJiraProjects: 'JiraProjects/LOAD_JIRA_PROJECTS',
      loadUserRates: 'UserRates/LOAD_USER_RATES',
    }),
    // checkToken(){
    //     axios.get('/api/check_token').then((response) => {
    //         $('meta[name="csrf-token"]').attr('content', response.data);
    //         window.axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data;
    //     }, (err) => {
    //         console.log(err);
    //     });
    // }
  },
  watch: {
    '$route'(to, from) {
      if (to.name === 'ProjectTabPlanning' && from.name !== 'ProjectsOverview') {
        this.$store.state.Filters.filters = {
          routeName: '',
          parameters: {}
        };
      }
      if (to.name === 'ProjectsOverview' && from.name !== 'ProjectTabPlanning') {
        this.$store.state.Filters.filters = {
          routeName: '',
          parameters: {}
        };
      }
    }
  },
  created: function () {
    // this.checkToken();

    // setInterval(function () {
    //     this.checkToken();
    // }.bind(this), 1200000);
  },
  mounted() {
    if (this.isLoggedIn) {
      this.LOAD_USER_INFO();
      this.loadJiraUsers();
      this.loadJiraActiveUsers();
      this.loadJiraProjects();
      this.loadUserRates();
    }

    Vue.set(window, 'googleChartsLoaded', false);
    GoogleCharts.load(() => {
      Vue.set(window, 'googleChartsLoaded', true);
      window.dispatchEvent(new Event('google-charts-loaded'));
    }, { packages: ['corechart', 'timeline'] });

    // console.log('Mounted app');

    CKEDITOR.config.toolbar = [
      { name: 'document', items: ['Source', '-'] },
      { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
      { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
      { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
      { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'] },
      { name: 'clipboard', items: ['Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
      '/',
      { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
      { name: 'colors', items: ['TextColor', 'BGColor'] },
      { name: 'tools', items: ['Maximize', 'ShowBlocks'] },
      { name: 'editing', items: ['Find', 'Replace', '-'] },
      { name: 'about', items: ['About'] }
    ];

    CKEDITOR.config.font_defaultLabel = 'Calibri';
    CKEDITOR.config.font_names = 'Calibri/Calibri, Verdana, Geneva, sans-serif;'
          + 'Arial/Arial, Helvetica, sans-serif;'
          + 'Comic Sans MS/Comic Sans MS, cursive;'
          + 'Courier New/Courier New, Courier, monospace;'
          + 'Georgia/Georgia, serif;'
          + 'Lucida Sans Unicode/Lucida Sans Unicode, Lucida Grande, sans-serif;'
          + 'Tahoma/Tahoma, Geneva, sans-serif;'
          + 'Times New Roman/Times New Roman, Times, serif;'
          + 'Trebuchet MS/Trebuchet MS, Helvetica, sans-serif;'
          + 'Verdana/Verdana, Geneva, sans-serif';
    CKEDITOR.config.fontSize_sizes = '8/8pt;9/9pt;10/10pt;11/11pt;12/12pt;14/14pt;16/16pt;18/18pt;20/20pt;22/22pt;24/24pt;26/26pt;28/28pt;36/36pt;48/48pt;72/72pt';
    CKEDITOR.config.fontSize_defaultLabel = '10';
    CKEDITOR.config.format_p = { element: 'p', name: 'Normal', styles: { 'font-size': '10pt' } };
    CKEDITOR.config.format_h1 = { element: 'h1', name: 'Heading 1', styles: { 'font-family': 'Calibri', 'margin-top': '12pt', 'font-size': '16pt' } };
    CKEDITOR.config.format_h2 = { element: 'h2', name: 'Heading 2', styles: { 'font-family': 'Calibri', 'margin-top': '2pt', 'font-size': '13pt' } };
    CKEDITOR.config.format_h3 = { element: 'h3', name: 'Heading 3', styles: { 'font-family': 'Calibri', 'margin-top': '2pt', 'font-size': '12pt' } };
    CKEDITOR.config.format_h4 = { element: 'h4', name: 'Heading 4', styles: { 'font-family': 'Calibri', 'font-style': 'italic', 'margin-top': '2pt', 'font-size': '11pt' } };

    // CKEDITOR.config.styles_noSpacing = {name: 'No spacing', element: 'p', styles: {'margin-top': '0px', 'margin-bottom': '0px', 'font-size': '10pt'}};
    // CKEDITOR.config.styles_title = {name: 'Title', element: 'h1', styles: {'font-size': '20pt', 'margin-top': '24pt', 'margin-bottom': '12pt'}};
    // CKEDITOR.config.styles_subTitle = {name: 'Subtitle', element: 'h2', styles: {'font-size': '17pt', 'margin-top': '24pt', 'margin-bottom': '12pt'}};

    CKEDITOR.stylesSet.add('default', [
      { name: 'Strikethrough', element: 'strike' },
      { name: 'Subscript', element: 'sub' },
      { name: 'Superscript', element: 'sup' },

      { name: 'Marker', element: 'span', attributes: { class: 'marker' } },

      { name: 'Big', element: 'big' },
      { name: 'Small', element: 'small' },
      { name: 'Typewriter', element: 'tt' },

      { name: 'Computer Code', element: 'code' },
      { name: 'Keyboard Phrase', element: 'kbd' },
      { name: 'Sample Text', element: 'samp' },
      { name: 'Variable', element: 'var' },

      { name: 'Deleted Text', element: 'del' },
      { name: 'Inserted Text', element: 'ins' },

      { name: 'Cited Work', element: 'cite' },
      { name: 'Inline Quotation', element: 'q' },

      { name: 'Language: RTL', element: 'span', attributes: { dir: 'rtl' } },
      { name: 'Language: LTR', element: 'span', attributes: { dir: 'ltr' } },
      { name: 'No spacing', element: 'p', styles: { 'margin-top': '0px', 'margin-bottom': '0px', 'font-size': '10pt' } },
      { name: 'Title', element: 'h1', styles: { 'font-size': '20pt', 'margin-top': '24pt', 'margin-bottom': '12pt' } },
      { name: 'Subtitle', element: 'h2', styles: { 'font-size': '17pt', 'margin-top': '24pt', 'margin-bottom': '12pt' } },
    ]);
  }
});
